const initialState = {
  drawing: {
    isActive: false,
    winnersPrizes: {},
    myUid: null,
    pageCount: null,
  },
}

const matchers = [
  [
    ({ type }) => type === 'requests/game/get-index/fulfilled',
    (state, { payload: { raffle } }) => {
      if (!raffle) return
      const { is_finish } = raffle
      state.drawing.isActive = is_finish === 1
    },
  ],
  [
    ({ type }) => type === 'requests/drawing-result/winners/get/fulfilled',
    (
      state,
      {
        meta: {
          arg: { page },
        },
        payload: { prizes },
      },
    ) => {
      const {
        drawing: { winnersPrizes, myUid },
      } = state
      if (prizes?.length)
        state.drawing.winnersPrizes = {
          ...winnersPrizes,
          [page]: prizes.filter(({ userUid }) => userUid !== myUid),
        }
      else state.drawing.pageCount = page - 1
    },
  ],
  [
    () => true,
    (state, { payload = {} }) => {
      if (!!payload?.profile) state.drawing.myUid = payload.profile.uid
    },
  ],
]

export const drawingResultSegment = {
  initialState,
  matchers,
}
